import { useStore } from "zustand";
import { ClearImportJob, WatchPendingImportJob } from "@useCases/index";
import importJobStore from "@data/stores/importJob";
import { FirebaseImportJobRepository } from "@data/repositories/Firebase/FirebaseImportJobRepository";
import { ImportJob } from "@domain/models/ImportJob";

export default function useImportJob() {
  const { importJob } = useStore(importJobStore);

  const watchPendingImportJob = async (jobId: ImportJob["id"]) => {
    const useCase = new WatchPendingImportJob(
      new FirebaseImportJobRepository(importJobStore.getState())
    );

    useCase.execute(jobId);
  };

  const cleanImportJob = () => {
    const useCase = new ClearImportJob(importJobStore.getState());

    useCase.execute();
  };

  return {
    importJob,
    watchPendingImportJob,
    cleanImportJob,
  };
}
